import { on } from "delegated-events";
import { validateForm } from "@common/scripts/validation";

export default {
  init: () => {
    on("submit", "[data-validate-form]", (e) => {
      const form = e.currentTarget;
      const isValid = validateForm(form);

      if (!isValid) {
        e.preventDefault();
        return;
      }
    });
  },
};
